// Internet Explorer 9 and higher
((arr) => {
  arr.forEach((item) => {
    if (item.hasOwnProperty('remove')) {
      return;
    }
    Object.defineProperty(item, 'remove', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function remove() {
        if (this.parentNode !== null) {
          this.parentNode.removeChild(this);
        }
      },
    });
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

// resizeEnd event polyfill
window.addEventListener('resize', (e) => {
  if ( window._resizeEndPolyfillTimeout ) clearTimeout(window._resizeEndPolyfillTimeout);
  window._resizeEndPolyfillTimeout = setTimeout(() => {
    window.dispatchEvent(new Event('resizeEnd'));
  }, 200);
});

// scrollEnd event polyfill
window.addEventListener('scroll', (e) => {
  if ( window._scrollEndPolyfillTimeout ) clearTimeout(window._scrollEndPolyfillTimeout);
  window._scrollEndPolyfillTimeout = setTimeout(() => {
    window.dispatchEvent(new Event('scrollEnd'));
  }, 50);
});



// WEBPACK FOOTER //
// ./fe/web-warehouse/src/js/polyfill.js